import { useEffect } from "react";
import "./Home.css";
import OfferingServicePage from "../Offering-ServicePage/Offering-service";
import PartnershipPage from "../PartnershipPage/Partnership";
import FooterContactPage from "../FooterContactPage/FooterContact";
import HeroSection from "./HeroSection/HeroSection";
import QuickNav from "./HeroSection/QuickNav";
import Solutions from "./Solutions/Solutions.jsx";
import Industries from "./IndustriesWeWork/IndustriesWeWork";
import NewReview from "./Review/NewReview";
import OurGlobalClient from "./OurGlobalClient";
import OurTechAndFrame from "./OurTechAndFram/OurTechAndFrame";
import LatestArticle from "./LatestArticle/LatestArticle";
import AboutUsPage from "../AboutUs-Page/about-us.js";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const QuickNavItems = [
    "Partner",
    "About US",
    "Services",
    "Solutions",
    "Technologies",
    "Stories",
    "Global",
    "Blogs",
    "Industries",
    "F&Q",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main-section-color">
      <Helmet>
        <title>
          Offshore Software Development in Bangladesh | Quad Theory Ltd
        </title>
      </Helmet>

      <HeroSection />
      <main>
        <QuickNav items={QuickNavItems} />
        <PartnershipPage />
        <AboutUsPage />
        <OfferingServicePage />
        <Solutions />
        <OurTechAndFrame></OurTechAndFrame>
        <NewReview></NewReview>
        <OurGlobalClient></OurGlobalClient>
        <LatestArticle></LatestArticle>
        <Industries />
      </main>
      <FooterContactPage />
    </div>
  );
};

export default Home;
